import React from 'react'

const CreateShowAssetsComponent = () => {
    return (
        <div>

        </div>
    )
}

export default CreateShowAssetsComponent